import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";
import { PartCard } from "../parts/PartCard";

const container = { hidden: {}, visible: { transition: { staggerChildren: 0.1 } } };

export function FeaturedParts() {
  const [parts, setParts] = useState([]);

  useEffect(() => {
    api.get("/parts", { params: { featured: true } }).then((res) => setParts(res.data)).catch(() => setParts([]));
  }, []);

  if (!parts.length) return null;

  return (
    <section className="py-24 bg-carbon border-y border-amber-500/10" data-testid="featured-parts-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-mono uppercase tracking-[0.25em] text-amber-light">Field-Proven Hardware</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl uppercase text-white mt-2">Featured Components</h2>
          </div>
          <Link to="/catalog" className="hidden sm:inline-flex items-center gap-2 text-sm font-mono uppercase text-zinc-400 hover:text-amber-light" data-testid="featured-view-all-link">
            View Full Catalog <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <motion.div variants={container} initial="hidden" whileInView="visible" viewport={{ once: true, margin: "-60px" }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {parts.slice(0, 8).map((p) => (
            <PartCard key={p.sku} part={p} />
          ))}
        </motion.div>
      </div>
    </section>
  );
}
